module.exports = __webpack_public_path__ + "static/media/leo.33283ca3.svg";